import React from "react";
import { EyeIcon, EyeSmallIcon, SearchIcon, ZapIcon } from "./PrivacyIcons";

const PRIVACY_ITEMS = [
  {
    id: "profileVisibility",
    label: "Profile Visibility",
    desc: "Allow others to view your profile",
    icon: EyeSmallIcon,
  },
  {
    id: "searchVisibility",
    label: "Search Visibility",
    desc: "Appear in search results",
    icon: SearchIcon,
  },
  {
    id: "activityStatus",
    label: "Activity Status",
    desc: "Show when you're online",
    icon: ZapIcon,
  },
];

const PrivacySettingsCard = ({ privacyToggles, setPrivacyToggles }) => {
  const toggle = (id) => {
    setPrivacyToggles((prev) => ({ ...prev, [id]: !prev[id] }));
  };

  return (
    <div className="v2-privacy-pg-card">
      <div className="v2-privacy-pg-card__header">
        <div className="v2-privacy-pg-card__icon-wrap" style={{ background: "#fef2f2" }}>
          <EyeIcon size={20} color="#eb1414" />
        </div>
        <div>
          <h3 className="v2-privacy-pg-card__title">Privacy Settings</h3>
          <p className="v2-privacy-pg-card__subtitle">
            Control who can see your information
          </p>
        </div>
      </div>
      <div className="v2-privacy-pg-card__body">
        {PRIVACY_ITEMS.map((item) => {
          const Icon = item.icon;
          const isOn = privacyToggles[item.id];
          return (
            <div className="v2-privacy-pg-toggle-item" key={item.id}>
              <div className="v2-privacy-pg-toggle-item__left">
                <div className="v2-privacy-pg-toggle-item__icon">
                  <Icon size={18} color="#eb1414" />
                </div>
                <div className="v2-privacy-pg-toggle-item__text">
                  <span className="v2-privacy-pg-toggle-item__label">{item.label}</span>
                  <span className="v2-privacy-pg-toggle-item__desc">{item.desc}</span>
                </div>
              </div>
              <button
                className={`v2-privacy-pg-toggle${isOn ? " v2-privacy-pg-toggle--on" : ""}`}
                onClick={() => toggle(item.id)}
              >
                <span className="v2-privacy-pg-toggle__knob" />
              </button>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default PrivacySettingsCard;
